// extracted by mini-css-extract-plugin
export default {"root":"style_root__hxW66","button":"style_button__n-g0x","fullscreen":"style_fullscreen__yJ6nE","leave":"style_leave__jZAqs","qa":"style_qa__ZErtn"};